export default __webpack_public_path__ + "static/media/swap_style2.816f1ea5.svg";